"use client";

import { useMemo } from "react";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "../ui/breadcrumb";
import React from "react";
import { cn } from "@/lib/utils/utils";

interface BreadCrumbListProps {
  className?: string;
  items: Array<{
    name: string;
    href?: string;
  }>;
}
const BreadCrumbList: React.FC<BreadCrumbListProps> = ({
  className,
  items,
}) => {
  if (!items || items?.length == 0) return;

  const length = useMemo(() => {
    return items?.length;
  }, [items]);

  return (
    <Breadcrumb className={cn("my-5", className)}>
      <BreadcrumbList className="xl:text-xl md:text-lg text-sm px-4">
        {items?.map((item, index) => {
          const currentIndex = index + 1;
          const activeClasses = `${
            currentIndex === length && "text-white font-bold"
          }`;

          return (
            <React.Fragment key={`item-${currentIndex}`}>
              <BreadcrumbItem>
                {item?.href ? (
                  <BreadcrumbLink className={activeClasses} href={item?.href}>
                    {item.name}
                  </BreadcrumbLink>
                ) : (
                  <BreadcrumbPage className={activeClasses}>
                    {item.name}
                  </BreadcrumbPage>
                )}
              </BreadcrumbItem>
              {currentIndex < length && <BreadcrumbSeparator />}
            </React.Fragment>
          );
        })}
      </BreadcrumbList>
    </Breadcrumb>
  );
};

export default BreadCrumbList;
